import { ShowMessage } from "../components/ShowMessage/ShowMessage";
import { CodeFileType, TreeData } from "../components/tree/CodeTree";

export const reMadeTree = (arr: TreeData[]) => {
  const newArr = arr.map((item) => {
    item.key = item.path;
    item.isOpen = false;
    item.title = item.path.split("/").reverse()[0];
    if (item.type === CodeFileType.tree && item.children) {
      item.leaf = false;
      item.children = reMadeTree(item.children);
    } else {
      item.leaf = true;
    }
    return item;
  });
  return newArr;
};
// 判断是否微信环境
export const isWeChatBrowser = () => {
  var userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf("micromessenger") !== -1;
};

export const checkLogin = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return false;
  }
  return true;
};

export const fallbackCopyTextToClipboard = (text: string) => {
  // 创建一个临时的textarea元素
  var tempTextarea = document.createElement("textarea");
  tempTextarea.value = text;

  // 将textarea元素添加到文档中
  document.body.appendChild(tempTextarea);

  // 选择textarea中的文本
  tempTextarea.select();
  tempTextarea.setSelectionRange(0, 999999); // For mobile devices

  // 执行复制命令
  try {
    var successful = document.execCommand("copy");
    var msg = successful ? "successful" : "unsuccessful";
    ShowMessage.success("复制成功");
  } catch (err) {
    ShowMessage.error(`复制失败${err}`);
  }

  // 移除临时的textarea元素
  document.body.removeChild(tempTextarea);
};
